export default __webpack_public_path__ + "eca1674e7e59a14c8faefca83b91ba5c.png";